<template lang="pug">
.booking-product-overview
  SlideInPanel(:isOpen="isShownOverview" @close="hideOverview")
    FetchErrorTransition(:isFetching="isFetchingBooking" :error="fetchBookingError" style="display: block;")
      OverviewWrapper(
        v-if="isShownOverview"
        :bookingDetails="getActiveBooking"
      )
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import SlideInPanel from '@v/components-global/layout/SlideInPanel.vue'
import OverviewWrapper from './BookingProductCardOverview/OverviewWrapper.vue'

export default {
  name: 'BookingProductCardOverview',
  components: { SlideInPanel, OverviewWrapper },
  computed: {
    ...mapState('planboardModule', ['fetchBookingError', 'isFetchingBooking']),
    ...mapGetters('planboardModule', ['planboardData', 'isShownOverview', 'getActiveBooking']),
  },
  methods: {
    ...mapActions('planboardModule', ['hideOverview']),
  },
}
</script>

<style lang="stylus">
.booking-product-overview .fixed .slide-in-wrapper
  top 80px // app-topbar-height
  box-shadow -4px 0px 10px rgba(0, 0, 0, 0.25)
  height calc(100vh - 80px)

  .slide-in-panel
    width 440px
    color #121D32
    height 100%
</style>
